// extracted by mini-css-extract-plugin
export default {"legal-disclaimer":"SeeDefinitions_legal-disclaimer__+EShi"};